import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import createWrapperAndAppendToBody from './createWrapperAndAppendToBody'

const ReactPortal = ({
  children = null,
  wrapperId = 'react-portal-wrapper',
}) => {
  let wrapper = document.getElementById(wrapperId)
  if (!wrapper) {
    wrapper = createWrapperAndAppendToBody(wrapperId)
  }
  return createPortal(children, wrapper)
}
export default ReactPortal

ReactPortal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
  wrapperId: PropTypes.string,
}
